export const NAME = "Calendarview"
export const FORM_NAME = `${NAME}/CalendarForm`
export const DELETE_FORM_NAME = `${NAME}/CalendarDeleteForm`
